import React from 'react';
import {connect} from 'react-redux';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import css from './Settings.module.css';
import {setShowSettings} from "../../../store/coreSlice";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import {Select} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import {chooseShowTraffic, chooseTheme, chooseUseGps, chooseShowPokemonLevel} from "../../../store/settingsSlice";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ClearHiddenMarkers from "./ClearHiddenMarkers";
import LinkDiscordButton from "../../Helper/Discord/LinkDiscordButton";

const Settings = (props) => {
	return (<Dialog
		className={css.Settings}
		open={props.showSettings}
		maxWidth='md'
		fullWidth={true}
	>
		<DialogTitle id="alert-dialog-title">Settings</DialogTitle>
		<DialogContent>
			<FormControl className={css.ThemeControl}>
				<InputLabel>Map Theme</InputLabel>
				<Select value={props.theme} onChange={(e) => props.chooseTheme(e.target.value)}>
					<MenuItem value="classic">Classic</MenuItem>
					<MenuItem value="earthy">Earthy</MenuItem>
					<MenuItem value="pokemon">Pokemon</MenuItem>
					<MenuItem value="verbose">Verbose</MenuItem>
				</Select>
			</FormControl>

			<FormControlLabel className={css.TrafficControl} control={(
				<Checkbox
					checked={props.showTraffic}
					onChange={(e) => props.chooseShowTraffic(e.target.checked)}
				/>
			)} label='Show Traffic' />

			<FormControlLabel className={css.GpsControl} control={(
				<Checkbox
					checked={props.useGps}
					onChange={(e) => props.chooseUseGps(e.target.checked)}
				/>
			)} label='Enable GPS' />

			<FormControlLabel className={css.LevelControl} control={(
				<Checkbox
					checked={props.showPokemonLevel}
					onChange={(e) => props.chooseShowPokemonLevel(e.target.checked)}
				/>
			)} label='Show Pokemon Level (Instead of CP)' />

			<ClearHiddenMarkers />
			<LinkDiscordButton onOpen={() => props.setShowSettings(false)} />
		</DialogContent>
		<DialogActions>
			<Button onClick={() => props.setShowSettings(false)} color="primary" autoFocus>
				Close
			</Button>
		</DialogActions>

	</Dialog>);
};

const mapStateToProps = (state) => {
	return {
		showSettings: state.core.showSettings,
		showTraffic: state.settings.showTraffic,
		showPokemonLevel: state.settings.showPokemonLevel,
		useGps: state.settings.useGps,
		theme: state.settings.theme,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		chooseTheme: (theme) => dispatch(chooseTheme(theme)),
		chooseUseGps: (val) => dispatch(chooseUseGps(val)),
		chooseShowTraffic: (val) => dispatch(chooseShowTraffic(val)),
		chooseShowPokemonLevel: (val) => dispatch(chooseShowPokemonLevel(val)),
		setShowSettings: (val) => dispatch(setShowSettings(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);